import React from 'react'

import BoardLeft from './BoardLeft.js'
import BoardRight from './BoardRight.js'
import Timer from './Timer.js'
import '../../styles/RoadMapStyles/roadmap.css'
import q218 from './../../resources/RoadMapResources/q2-bg.svg'
import q318 from './../../resources/RoadMapResources/q3-bg.svg'
import q418 from './../../resources/RoadMapResources/q4-bg.svg'
import q119 from './../../resources/RoadMapResources/q1-19-bg.svg'
import q219 from './../../resources/RoadMapResources/q2-19-bg.svg'
import q319 from './../../resources/RoadMapResources/q3-19-bg.svg'
import q419 from './../../resources/RoadMapResources/q4-19-bg.svg'

import checked from './../../resources/RoadMapResources/checked.svg'
import unchecked from './../../resources/RoadMapResources/unchecked.svg'

import PipeOne from './../../resources/RoadMapResources/pipe-1-white.svg'
import PipeTwo from './../../resources/RoadMapResources/pipe-2-white.svg'
import PipeTimer from './../../resources/RoadMapResources/pipe-timer.svg'

import {connect} from 'react-redux'


class RoadMap extends React.Component{
    render(){
        return(
            <section className="rm__sec" id='our-roadmap-anchor'>
                <div className="rm__container">

                    <h1 className="rm__title title">
                        Road map
                    </h1>

                    {(this.props.windowDimensions.windowWidth > 1000) ?
                        <div className="rm__pipe-container">

                            <div className="rm__pipe-1">
                                <img src={PipeOne} />
                                <div className="rm__pipe-1-1"/>
                                <div className="rm__pipe-1-2"/>
                                <div className="rm__pipe-1-3"/>
                                <div className="rm__pipe-1-4"/>
                            </div>

                            <div className="rm__pipe-2">
                                <img src={PipeOne} />
                                <div className="rm__pipe-2-1"/>
                                <div className="rm__pipe-2-2"/>
                                <div className="rm__pipe-2-3"/>
                                <div className="rm__pipe-2-4"/>
                            </div>

                            <div className="rm__pipe-3">
                                <img src={PipeOne} />
                                <div className="rm__pipe-1-1"/>
                                <div className="rm__pipe-1-2"/>
                                <div className="rm__pipe-1-3"/>
                                <div className="rm__pipe-1-4"/>
                            </div>

                            <div className="rm__pipe-4">
                                <img src={PipeOne} />
                                <div className="rm__pipe-2-1"/>
                                <div className="rm__pipe-2-2"/>
                                <div className="rm__pipe-2-3"/>
                                <div className="rm__pipe-2-4"/>
                            </div>

                            <div className="rm__pipe-5">
                                <img src={PipeOne} />
                                <div className="rm__pipe-1-1"/>
                                <div className="rm__pipe-1-2"/>
                                <div className="rm__pipe-1-3"/>
                                <div className="rm__pipe-1-4"/>
                            </div>

                            <div className="rm__pipe-6">
                                <img src={PipeOne} />
                                <div className="rm__pipe-2-1"/>
                                <div className="rm__pipe-2-2"/>
                                <div className="rm__pipe-2-3"/>
                                <div className="rm__pipe-2-4"/>
                            </div>

                        </div>
                        :
                        null
                    }

                    <div className="rm__rm">
                        <div className="rm__left">
                            {/* {(this.props.windowDimensions.windowWidth > 1000) ?
                                null
                                :
                                <div className="rm__timer">
                                    <Timer/>
                                </div>
                            } */}
                            <BoardLeft
                                quater={'2'}
                                year={'2018'}
                                bgimg={q218}
                                cimg={checked}
                                items={['Concept development']}
                            />
                            {(this.props.windowDimensions.windowWidth > 1000) ?
                                null
                                :
                                <BoardRight
                                    quater={'3'}
                                    year={'2018'}
                                    bgimg={q318}
                                    cimg={checked}
                                    items={['Exchange licence acquisition','Private sale']}
                                />
                            }
                            <BoardLeft
                                quater={'4'}
                                year={'2018'}
                                bgimg={q418}
                                cimg={unchecked}
                                items={['ICO (2 months)','KRONN token listing']}
                            />
                            {(this.props.windowDimensions.windowWidth > 1000) ?
                                null
                                :
                                <BoardRight
                                    quater={'1'}
                                    year={'2019'}
                                    bgimg={q319}
                                    cimg={unchecked}
                                    items={[<div>KRONN & Fiat exchange <br/> service launch</div>]}
                                />
                            }

                            <BoardLeft
                                quater={'2'}
                                year={'2019'}
                                bgimg={q219}
                                cimg={unchecked}
                                items={['Launch of Main Net', 'Coin distribution', 'Wallet app']}
                            />
                            {(this.props.windowDimensions.windowWidth > 1000) ?
                                null
                                :
                                <BoardRight
                                    quater={'3'}
                                    year={'2019'}
                                    bgimg={q119}
                                    cimg={unchecked}
                                    items={['KRONN Exchange launch','KRONN Exchange app']}
                                />
                            }
                            <BoardLeft
                                quater={'4'}
                                year={'2019'}
                                bgimg={q419}
                                cimg={unchecked}
                                items={['KRONN Bank launch','Card launch']}
                            />
                        </div>

                        {(this.props.windowDimensions.windowWidth > 1000) ?
                            <div className="rm__right">

                                {/* <div className="rm__timer">
                                    <Timer/>
                                    <div className="rm__timer-pipe">
                                        <img src={PipeTimer} />
                                        <div className="rm__timer-1" />
                                        <div className="rm__timer-2" />
                                        <div className="rm__timer-3" />
                                        <div className="rm__timer-4" />
                                    </div>
                                </div> */}

                                <BoardRight
                                    quater={'3'}
                                    year={'2018'}
                                    bgimg={q318}
                                    cimg={checked}
                                    items={['Exchange licence acquisition','Private sale']}
                                />
                                <BoardRight
                                    quater={'1'}
                                    year={'2019'}
                                    bgimg={q319}
                                    cimg={unchecked}
                                    items={[<div>KRONN & Fiat exchange <br/> service launch</div>]}

                                />
                                <BoardRight
                                    quater={'3'}
                                    year={'2019'}
                                    bgimg={q119}
                                    cimg={unchecked}
                                    items={['KRONN Exchange launch','KRONN Exchange app']}
                                />
                            </div>
                            :
                            null
                        }
                    </div>
                </div>
            </section>
        )
    }
}

const mapStatesToProps = (state) =>{
    return{
        windowDimensions: state.windowDimensions,
    }
}


export default connect(mapStatesToProps)(RoadMap)



// WEBPACK FOOTER //
// ./src/components/RoadMap/RoadMap.js